jQuery(function(e){

    //configShowOnlyMore1

    jQuery("body").on("change","#configShowOnlyMore1",function(e){

        original=jQuery(this).closest(".appComponent").data("data-is-login");
         if(jQuery(this).is(":checked")){
           
            jQuery(this).closest(".appComponent").addClass("configShowOnlyMore1");
         }else{
            jQuery(this).closest(".appComponent").removeClass("configShowOnlyMore1");
         }
    });

    jQuery("body").on("change","#configHideBubbles",function(e){

        original=jQuery(this).closest(".appComponent").data("data-is-login");
         if(jQuery(this).is(":checked")){
           
            jQuery(this).closest(".appComponent").addClass("configHideBubbles");
         }else{
            jQuery(this).closest(".appComponent").removeClass("configHideBubbles");
         }
    });

    jQuery("body").on("change","#viewAsPublic",function(e){

        original=jQuery(this).closest(".appComponent").data("data-is-login");
         if(jQuery(this).is(":checked")){
           
            jQuery(this).closest(".appComponent").addClass("viewAsPublic");
         }else{
            jQuery(this).closest(".appComponent").removeClass("viewAsPublic");
         }
    });

    jQuery("body").on("change","#viewAsReComplete",function(e){

        original=jQuery(this).closest(".appComponent").data("data-is-login");
         if(jQuery(this).is(":checked")){
           
            jQuery(this).closest(".appComponent").addClass("viewAsReComplete");
         }else{
            jQuery(this).closest(".appComponent").removeClass("viewAsReComplete");
         }
    });

});